import React, { useState } from 'react'
import { SelectTreeViewProps } from './SelectTreeView.types'
import styles from './SelectTreeView.module.scss'
import cl from 'classnames'
import { Input } from '../Input'
import { HorizontalLine } from '../HorizontalLine'
import { TreeViewDropdownLine, TreeViewDropdownLineProps } from './TreeViewDropdownLine'
import { Button } from '../Button'
import { IconArrowDown, IconArrowUp } from 'assets'
import { Text1 } from '../Text1'
import { Tag } from '../Tag'
import { PlusNumber } from '../PlusNumber'

const SelectTreeViewComponent = (props: SelectTreeViewProps) => {
  const {
    className,
    style,
    selectAllOptionProps,
    options,
    disabled: disabledFromProps,
    onDropdownCollapse
  } = props

  const disabled: boolean = disabledFromProps || Boolean(!options || !options.length)

  const [showDropdown, setShowDropdown] = useState<boolean>(null)

  const onOpenCollapseDropdownClick = () => {
    if (disabled) return

    if (showDropdown) {
      // document.removeEventListener('click', handleOutsideClick, false)
      setShowDropdown(false)
      onDropdownCollapse && onDropdownCollapse()
    } else {
      // document.addEventListener('click', handleOutsideClick, false)
      setShowDropdown(true)
    }
  }

  // useEffect(() => {
  //   if (showDropdown === false) {
  //     onDropdownCollapse && onDropdownCollapse()
  //   }
  // }, [onDropdownCollapse, showDropdown])

  const areAllOptionsSelected = selectAllOptionProps.isSelected

  const selectedOptions: TreeViewDropdownLineProps[] = []
  const getSelectedOptions = (optns: TreeViewDropdownLineProps[]) => {
    if (areAllOptionsSelected) return

    optns.forEach(o => {
      if (o.children && o.children.length) {
        getSelectedOptions(o.children)
      } else if (o.isSelected) {
        selectedOptions.push(o)
      }
    })
  }
  getSelectedOptions(options)
  const selectedOptionsCount = selectedOptions.length

  const [searchText, setSearchText] = useState('')

  const doesIncludeSearchText = (o: TreeViewDropdownLineProps) => {
    const includesSearchText = o.label.trim().toLowerCase()
      .includes(searchText.trim().toLowerCase())
    if (includesSearchText) return true
    if (o.children && o.children.length) {
      return o.children.some(doesIncludeSearchText)
    }
  }
  const filteredOptions = options.filter(doesIncludeSearchText)

  let hideDropdownTimeout: NodeJS.Timeout = null

  return (
    <div
      className={cl(styles.container, className)}
      style={style}
    // onMouseLeave={() => {
    //   hideDropdownTimeout =
    //     setTimeout(onOpenCollapseDropdownClick, 500)
    // }}
    // onMouseEnter={() => {
    //   clearTimeout(hideDropdownTimeout)
    // }}
    >
      <div
        className={cl(styles.stateIndicator, {
          [styles.active]: showDropdown,
          [styles.disabled]: disabled
        })}
        onClick={onOpenCollapseDropdownClick}
      >
        {areAllOptionsSelected
          ? (
            <Text1
              overflowEllipsis
              style={{ marginLeft: 5 }}
            >
              All
            </Text1>
          )
          : selectedOptionsCount === 0
            ? (
              <Text1
                overflowEllipsis
                style={{ marginLeft: 5 }}
              >
                None
              </Text1>
            )
            : (
              <>
                <Tag
                  className={styles.tag}
                  tag={selectedOptions[0]?.label}
                  removable
                  onRemove={selectedOptions[0]?.onClick}
                />
                {selectedOptionsCount > 1 && (
                  <PlusNumber
                    style={{ marginLeft: 'auto' }}
                    num={selectedOptions.length - 1}
                  />
                )}
              </>
            )
        }
        <Button
          preset='icon'
          className={styles.arrowButton}
          style={{ marginLeft: 'auto' }}
          onClick={onOpenCollapseDropdownClick}
          disabled={disabled}
        >
          {showDropdown
            ? <IconArrowUp />
            : <IconArrowDown />
          }
        </Button>
      </div>

      {
        showDropdown && (
          <div
            // ref={containerRef}
            className={styles.dropdownContainer}
            onMouseLeave={() => {
              hideDropdownTimeout =
                setTimeout(onOpenCollapseDropdownClick, 500)
            }}
            onMouseEnter={() => {
              clearTimeout(hideDropdownTimeout)
            }}
          >
            <Input
              placeholder='Search...'
              style={{ border: 0 }}
              value={searchText}
              onChange={setSearchText}
            />
            <HorizontalLine style={{ margin: 0 }} />

            <TreeViewDropdownLine
              {...selectAllOptionProps}
              style={{ padding: '0 12px' }}
            />

            <HorizontalLine style={{ margin: 0 }} />

            <div className={cl(styles.dropdownLinesContainer, styles.scrollable)}>
              {filteredOptions.map((option, index) => {
                return (
                  <TreeViewDropdownLine
                    key={index}
                    {...option}
                  />
                )
              })}
            </div>

          </div>
        )
      }
    </div >
  )
}

const SelectTreeView = SelectTreeViewComponent
export { SelectTreeView }
